/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：917
 */

"use strict"

function i() {
  return "[object process]" === Object.prototype.toString.call("undefined" !== typeof process ? process : 0)
}
function o(e, t) {
  return e.require(t)
}
export { i as b }
export { o as a }
export default o
